var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.973 41.572l31.052-16.691a1 1 0 000-1.762L8.973 6.428a1 1 0 00-1.473.88v33.383a1 1 0 001.473.881zm32.473-14.049c2.808-1.51 2.808-5.537 0-7.046L10.394 3.785C7.729 2.353 4.5 4.283 4.5 7.31v33.38c0 3.026 3.229 4.956 5.894 3.524l31.052-16.692z"}));
}

Play.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Play;

Play.default = Play;
